import React, {useRef, useEffect, useState,} from "react";

import './assets/css/cameraTab.css';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage, ref, uploadBytes , getDownloadURL, uploadBytesResumable, on } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB3SQwEX8j4b9SDRiEAkSLC7SOXeNkw6Rg",
  authDomain: "g-test-project-d619d.firebaseapp.com",
  projectId: "g-test-project-d619d",
  storageBucket: "g-test-project-d619d.appspot.com",
  messagingSenderId: "335293664191",
  appId: "1:335293664191:web:8dcc86c39cbcbf7c4def0a",
  measurementId: "G-CGDG7TDQ38"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage();

const date = new Date();

let mediaRecorder;

let recordedChunks;
let recordedBlob;

export default function CameraTab(props)
{
    // Generic camera variables
    const [camMode, setCamMode] = useState('environment');

    const camRef = useRef(null);
    useEffect(() => {
        setCamMode('environment');
        setupCamera();
        }, [camRef]
    )

    const [isOn, setIsOn] = useState(false);

    const [captureType, setCaptureType] = useState(2); // 0 == photo, 1 == video, 2 == stream
    const [isCapturing, setIsCapturing] = useState(false);   
    const [hasCapture, setHasCapture] = useState(false);
    
    const [isSrcReady, setIsSrcReady] = useState(false);
    const [isUploaded, setIsUploaded] = useState(false);  

    // Video specific
    
    const videoRef = useRef(null);

    // Photo specific

    const photoRef = useRef(null);

    const [time, setTime] = useState(0);
    const [id, setID] = useState(1);

    const [folderID, setFolderID] = useState(0);
    //const [interval, setInterval] = useState(0);

    const [running, setRunning] = useState(false);
    useEffect(() => {
        let interval;
      if (running) 
      {
        interval = setInterval(() => { setTime((prevTime) => prevTime + 10); }, 10);
        console.log("interval: " + interval) ;
        console.log("time: " + time) ;

        if(time > 1000)
        {
            setTime(0);
            takeStreamSnapshot();
            uploadStreamSnapshot();

            if(id > 10)
            {
                stopStream();
            }
        }

      } 
      else if (!running) 
      {
        clearInterval(interval);
      }
      return () => clearInterval(interval);
    });
      
    console.log("===================== Capture Tab Opened =====================");

    // ==================== For photo/image capture ====================

    function takePhoto() {

        //let video = camRef.current;
        let photo = photoRef.current;

        photo.width = resWidth;
        photo.height = resHeight;

        let ctx = photo.getContext('2d');
        ctx.drawImage(camRef.current, 0, 0, resWidth, resHeight);

        setHasCapture(true);
        setCaptureType(0);
    }
    
    function uploadPhoto() {
        setIsUploaded(true);

        // const imageDataURL = photoRef.current.toDataURL('image/png');
        // const fileRef = ref(storage, 'images/' + date.getTime() + '.png');

        photoRef.current.toBlob((blob) => {
            // const newImg = document.createElement('img');
            // const url = URL.createObjectURL(blob);
          
            // newImg.onload = () => {
            //   // no longer need to read the blob so it's revoked
            //   URL.revokeObjectURL(url);
            // };
            // newImg.src = url;
            // document.body.appendChild(newImg);
            // console.log(newImg);

            const fileRef = ref(storage, 'images/' + date.getTime() + '.png');
            
            uploadBytesResumable(fileRef, blob).then((snapshot) => {
            console.log('Uploaded a blob or file!');
            setIsUploaded(false);        
            alert(
                'Uploaded!' +
                '\n\nname: ' + snapshot.metadata.name +
                '\ncontent type: ' + snapshot.metadata.contentType +
                '\nsize: ' + snapshot.metadata.size +
                '\ncreated: ' + snapshot.metadata.timeCreated +
                '\nuploaded: ' + snapshot.metadata.updated);
            });
        });
    }

    function savePhoto() {
        //const imageDataURL = photoRef.current.toDataURL('image/png');
        OpenDownloadLink(photoRef.current.toDataURL('image/png'), "download", "png");
    }

    function closePhotoPreview() {
        let photo = photoRef.current;
        let ctx = photo.getContext('2d');

        ctx.clearRect(0, 0, photo.width, photo.height);

        setHasCapture(false);
    }
    
    // ==================== For video recording ====================

    function handleVideoRecord() {
        if (isCapturing) {
          stopRecording();
        } else {
          startRecording();
        }
    }

    function startRecording() {
        recordedChunks = [];
        mediaRecorder.start();
        setIsCapturing(true);
        setCaptureType(1);
        console.log('Recording Started');
    }

    function stopRecording() {
        mediaRecorder.stop();
        setIsCapturing(false);
        setHasCapture(true);
        console.log('Recording Stopped');
    }

    function handleDataAvailable(e) {
        if (e.data && e.data.size > 0) {
          recordedChunks.push(e.data);
        }
    }

    function handleStop(e) {
        setIsSrcReady(false);
        recordedBlob = new Blob(recordedChunks, { type: 'video/webm' });
        videoRef.current.src = URL.createObjectURL(recordedBlob);
        videoRef.current.controls = true;
        setIsSrcReady(true);
    }
       
    function saveVideo() {
        // let videoDataUrl = URL.createObjectURL(recordedBlob);
        OpenDownloadLink(videoRef.current.src, "download", "webm");
    }

    function uploadVideo() {
        setIsUploaded(true);

        const fileRef = ref(storage, 'videos/' + date.getTime() + '.webm');

        uploadBytesResumable(fileRef, recordedBlob).then((snapshot) => {
        console.log('Uploaded a blob or file!');
        setIsUploaded(false);        
        alert(
            'Uploaded!' +
            '\n\nname: ' + snapshot.metadata.name +
            '\ncontent type: ' + snapshot.metadata.contentType +
            '\nsize: ' + snapshot.metadata.size +
            '\ncreated: ' + snapshot.metadata.timeCreated +
            '\nuploaded: ' + snapshot.metadata.updated);
        });
    }

    function closeVideoPreview() {
        // Clear memory?        
        setHasCapture(false);
    }

    // ====================== Streaming and real-time uploading ======================

    function takeStreamSnapshot() {
        //let video = camRef.current;
        let photo = photoRef.current;

        photo.width = resWidth;
        photo.height = resHeight;

        let ctx = photo.getContext('2d');
        ctx.drawImage(camRef.current, 0, 0, resWidth, resHeight);

        //setHasCapture(true);
        // setCaptureType(0);
    }
    
    function uploadStreamSnapshot() {
        setIsUploaded(true);

        photoRef.current.toBlob((blob) => {

            const fileRef = ref(storage, 'images/' + folderID + '/' + date.getTime() + '-' + id + '.png');
            
            uploadBytesResumable(fileRef, blob).then((snapshot) => {
            console.log('Uploaded a blob or file!');
            setIsUploaded(false);
            console.log(
                'Uploaded!' +
                '\n\nname: ' + snapshot.metadata.name +
                '\nfolder: images/' + folderID + '/' + date.getTime() + '-' + id + '.png' + 
                '\ncontent type: ' + snapshot.metadata.contentType +
                '\nsize: ' + snapshot.metadata.size +
                '\ncreated: ' + snapshot.metadata.timeCreated +
                '\nuploaded: ' + snapshot.metadata.updated);
            });
            setID(id+1);
        });
    }

    function startStream ()
    {
        if(getOrientation() === 'portrait')
        {
            randomFolderName();
            setRunning(true);
            setIsCapturing(true);
        }
        else
        {
            alert(
                'Please tile device to portrait mode.'
            );
        }
    }

    function stopStream() {
        setRunning(false);
        setIsCapturing(false);
        setID(1);
    }

    // ====================== Shared/Generic ======================

    const [resWidth, setResWidth] = useState(0);
    const [resHeight, setResHeight] = useState(0);

    function setupCamera()
    {//width : {min: resWidth}, height: {min: resHeight},
        let stm = navigator.mediaDevices.getUserMedia ({ video : { facingMode: camMode, aspectRatio: true}, audio: false })
        .then(stream => { 
            let cam = camRef.current;
            cam.srcObject = stream;
            let settings = stream.getVideoTracks()[0].getSettings();
            setResWidth(settings.width);
            setResHeight(settings.height);
            // console.log(resWidth + " x " + resHeight);
            cam.oncanplay = e => {
                cam.play();
                console.log("Camera started");
                const options = { mimeType: 'video/webm' };
                cam.captureStream = cam.captureStream || cam.mozCaptureStream;
                mediaRecorder = new MediaRecorder(cam.captureStream(), options);
                mediaRecorder.ondataavailable = handleDataAvailable;
                mediaRecorder.onstop = handleStop;
                console.log('recorder is ready');
    
                setIsOn(true);
            }
        })

        .catch(err => {
            console.error(err);
        })
    }

    function handleSwitchCamera()
    {
        if(camMode === 'user')
        {
            setCamMode('environment');     
        }
        else
        {
            //wwww.facingMode = 'user';
            // navigator.mediaDevices.getUserMedia ({ video : { facingMode: 'user', width : 1920, height: 1080}, audio: false })
            setCamMode('user');
        }
        setupCamera();
    }


    function OpenDownloadLink(url, name = "download", type = "xml") {
        var templink = document.createElement("a");
        templink.style.display = "none";
        templink.href = url;
        console.log(url);
        templink.download = name + "." + type;
        document.body.appendChild(templink);
        templink.click();
        document.body.removeChild(templink);
    }

    function randomFolderName() {
        setFolderID(Math.floor(Math.random() * (9990 - 1 + 1)) + 1);
      }

    // ====================== Other stuff =====================

    function exitHandle()
    {
        if(!isCapturing)
        {
            return (
                <button className="exitButton" onClick={props.SwitchToCapture}>X</button>
            )
        }
    }

    function ToggleCaptureType()
    {
        if(!isCapturing)
        {
            return (
                <div>
                    <button className="captureButton" onClick={SwitchCaptureType}>
                        Toggle Capture Type
                    </button>
                </div>
            )
        }
    }

    function switchCaptureButton()
    {
        return (
            <button className="captureButton" onClick={handleSwitchCamera}>
                Switch Camera
            </button>
        )
    }

    function SwitchCaptureType()
    {
        if(captureType + 1 > 2)
        {
            setCaptureType(0);
        }
        else
        {
            setCaptureType(captureType + 1);
        }
    }

    function display()
    {
        switch(captureType)
        {
            case 0: //photo
                {
                    return (
                        !hasCapture ? (
                            <div>
                                <button className="captureButton" onClick={takePhoto}>Photo Capture</button> 
                            </div>
                        ) : (                
                            <div>
                                <button className="captureButton" onClick={uploadPhoto}>Upload Photo</button>
                                <button className="captureButton" onClick={savePhoto}>Save Photo</button>
                                <button className="captureButton" onClick={closePhotoPreview}>Close Photo Preview</button>
                            </div>
                        )
                    )
                }
            case 1: //video
                {
                    return (
                        !hasCapture ? ( 
                            !isCapturing ? (
                                <div>
                                    <button className="captureButton" onClick={handleVideoRecord}>Video Capture</button> 
                                </div>
                            ) : (                
                                <div>
                                    <button className="captureButton" onClick={handleVideoRecord}>Stop Recording</button> 
                                </div>
                            ) 
                        ) : (                
                            <div>
                                <button className="captureButton" onClick={uploadVideo}>Upload Video</button>
                                <button className="captureButton" onClick={saveVideo}>Save Video</button>
                                <button className="captureButton" onClick={closeVideoPreview}>Close Video Preview</button>
                            </div>
                        )
                    )
                }
            case 2: //stream
                {
                    return (
                        !running ? (
                            <div className="cameraButtonsContainer">                            
                                {/* {switchCaptureButton()} */}
                                <button className="captureButton" onClick={handleSwitchCamera} style={{ width: '33.33%' }}>Switch</button>
                                <button className="captureButton" onClick={startStream} style={{ width: '33.33%' }}>Start Stream</button> 
                                <div style={{ width: '33.33%' }}></div> 
                            </div>
                        ) : (
                            <div className="cameraButtonsContainer">  
                                <div style={{ width: '33.33%' }}></div> 
                                <button className="captureButton" onClick={stopStream} style={{ width: '33.33%' }}>Stop Stream</button> 
                                <div style={{ width: '33.33%' }}></div> 
                            </div>
                            )
                    )
                }
        }

    }

    function previewHandle()
    {
        switch(captureType)
        {
            case 0: //photo
                {
                    return (
                        <div className={'photo-Container ' + (hasCapture ? 'hasCapture' : '')}>
                            <canvas className="photoCanvas" ref={photoRef}></canvas>                
                        </div>
                    )
                }
            case 1: //video
                {
                    return (
                        <div className={'video-Container ' + (hasCapture ? 'hasCapture' : '')}>
                            <video ref={videoRef} className="videoCanvas" muted></video>               
                        </div>  
                    )
                }
            case 2: //stream
                {
                    return (
                        <canvas className="photoCanvas" ref={photoRef} hidden></canvas>
                    )
                }
        }       
    }

    function  detectOrientation()
    {        
        // // Via window dimensions

        // let width = window.innerWidth;
        // let height = window.innerHeight;
        
        // if(width > height)
        // {
        //     alert(
        //         width + 
        //         '\n' +
        //         height +
        //         '\n' +
        //         'landscape?'
        //     );
        // }
        // else if (width < height)
        // {
        //     alert(
        //         width + 
        //         '\n' +
        //         height +
        //         '\n' +
        //         'portrait?'
        //     );
        // }
        // else
        // {
        //     alert(
        //         width + 
        //         '\n' +
        //         height +
        //         '\n' +
        //         'square!?'
        //     );
        // }

        // View device orientation        
        console.log('======================== \n' + window.screen.orientation.type);
        if(window.screen.orientation.type === 'landscape-primary')
        {
            return (
                <div>
                    <p>Landscape mode</p>
                </div>
            )
        }
        else
        {
            return (
                <div>
                    <p>Some other mode</p>
                </div>
            )
        }
    }

    function  getOrientation()
    {
        // let width = window.innerWidth;
        // let height = window.innerHeight;
    

        // if(window.screen.orientation.type === 'landscape-primary')
        // {
        //     return (
        //         "landscape"
        //     )
        // }
        // else
        // {
            return (
                "portrait"
            )
        // }


    }
    // ===================== Return =====================


    return (
        <div className="fullScreen">

            <div className="camera-Container">
            <p className={'reconstructionCanvas ' + getOrientation()} style={{height:'40%'}}>Insert Reconstruction Here</p>
            <video className={'cameraCanvas ' + getOrientation()} ref ={camRef}></video>  
            </div> 

            {previewHandle()}
            
            {display()}   
            
            {exitHandle()}  

        </div>
    )
}

